
import { Product } from '../../types';

/**
 * Transform database product data to application Product type
 */
export const transformDatabaseToProduct = (item: any): Product => ({
  id: item.id,
  name: item.name,
  description: item.description,
  category: item.category as 'ostomy' | 'medicine' | 'other',
  currentStock: item.current_stock,
  usageRate: item.usage_rate || 1,
  minStockAlert: item.min_stock_alert,
  groupIds: [], // Will be populated from product_groups
  createdAt: new Date(item.created_at),
  updatedAt: new Date(item.updated_at),
  supplierName: item.supplier_name,
  supplierWebsite: item.supplier_website,
  supplierContact: item.supplier_contact,
  productCode: item.product_code,
  changeFrequency: item.change_frequency,
  nextChangeDate: item.next_change_date ? new Date(item.next_change_date) : undefined,
  packageSize: item.package_size,
});

/**
 * Transform Product type to database format
 * Converting Date objects to ISO strings for Supabase compatibility
 */
export const transformProductToDatabase = (product: Product, userId: string) => ({
  id: product.id,
  user_id: userId,
  name: product.name,
  description: product.description,
  category: product.category,
  current_stock: product.currentStock,
  min_stock_alert: product.minStockAlert,
  usage_rate: product.usageRate,
  supplier_name: product.supplierName,
  supplier_website: product.supplierWebsite,
  supplier_contact: product.supplierContact,
  product_code: product.productCode,
  change_frequency: product.changeFrequency,
  next_change_date: product.nextChangeDate ? product.nextChangeDate.toISOString() : null,
  package_size: product.packageSize,
});

/**
 * Transform between remote API format and application Product type
 * These aliases ensure backward compatibility with existing code
 */
export const transformRemoteToProduct = transformDatabaseToProduct;
export const transformProductToRemote = transformProductToDatabase;
